/**
 *
 * @param {array} sections
 * @returns {string}
 */
export function findFirstSectionVideo(sections) {
  let videoUrl = ""

  for (let i = 0; i < sections?.length; i++) {
    if (videoUrl) break
    const sectionComponents = sections[i]?.sectionComponents || []
    sectionComponents.forEach(component => {
      if (videoUrl) return
      const { url } =
        ((component && component.text) || []).find(
          ({ _type } = {}) => _type === "videoEmbed"
        ) || {}
      videoUrl = url
    })
  }

  return videoUrl
}
